import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PrivacyPolicy from './PrivacyPolicy';
import CookiePolicy from './CookiePolicy';
import reportWebVitals from './reportWebVitals';

if (window.location.hostname !== 'eazyproject.cloud' && window.location.hostname !== 'www.eazyproject.cloud' && window.location.hostname !== 'localhost') {
  window.location.replace('https://eazyproject.cloud' + window.location.pathname + window.location.search);
}

const path = window.location.pathname;
const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

let component: React.ReactElement;
if (path === '/privacy') component = <PrivacyPolicy />;
else if (path === '/cookies') component = <CookiePolicy />;
else component = <App />;

root.render(
  <React.StrictMode>
    {component}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
